import CryptoJS from "crypto-js";


export const generateKey = () => {
  return "retval_firstname"
  // return CryptoJS.lib.WordArray.random(32).toString(CryptoJS.enc.Hex);
};

export const sha256Encrypt = (data) => {
  return CryptoJS.SHA256(data).toString(CryptoJS.enc.Hex);
};
export const encryptData = (key,data,method='POST') => {
  const encrypted = CryptoJS.AES.encrypt(
    method == 'POST' ? JSON.stringify(data) : data,
    CryptoJS.enc.Utf8.parse(key),
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.ZeroPadding
    }
  );
  return encrypted.toString();
};

export const decryptData = (key,encryptedStr) => {
  const decrypted = CryptoJS.AES.decrypt(
    encryptedStr,
    CryptoJS.enc.Utf8.parse(key),
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.ZeroPadding 
    }
  );
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
};


// WEBPACK FOOTER //
// ./src/utils/crypto.js